import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import '@shui/core/sh-icon';
import '@shui/core/sh-toggle';
import { ConfirmDialogData } from './confirm-dialog.model';

/** Generic yes/no dialog. Resolves to `true` when confirmed, `false` or `undefined` otherwise. */
@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfirmDialogComponent {
    private readonly dialogRef = inject<MatDialogRef<ConfirmDialogComponent, boolean>>(MatDialogRef);

    protected readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

    protected cancel(): void {
        this.dialogRef.close(false);
    }

    protected confirm(): void {
        this.dialogRef.close(true);
    }
}
